// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__16Hvv","list":"PatternAutocomplete_list__1gxm7"};